<app-shared-search *ngIf="resolver" [resolver]="resolver" [searchOptions]="SEARCH_OPTIONS" (search)="onSearch($event)">
  <h1 search-header class="d-inline-block align-middle m-0">
    <a
      *ngIf="socialGroup"
      class="return-link"
      data-test-id="return-to-parent-page"
      [routerLink]="[socialGroup.entityLink + '/' + socialGroup.entityId]"
      [innerHtml]="
        'MANAGE_INVITE_TO_SOCIAL_GROUP_HINT'
          | translate: { name: socialGroup.name, group: socialGroup.type | lowercase }
      "
    ></a>
  </h1>

  <app-search-results-invite
    *ngIf="socialGroup"
    search-results
    [isSearchActive]="isSearchActive"
    [isAuthenticated]="isAuthenticated$ | async"
    [isLoading]="isLoading$ | async"
    [options]="SEARCH_OPTIONS"
    [searchState]="resolver.state"
    [inviteCardType]="CARD_TYPES[socialGroup.type]"
    [results]="results$ | async"
    (action)="onAction($event)"
    (pageChanged)="resolver.onPageChanged($event)"
    (sortCategory)="setSortCategory($event)"
    [socialGroupProfileIds]="socialGroup.membersIds"
    [isSocialGroupLeader]="isSocialGroupLeader$ | async"
  ></app-search-results-invite>
</app-shared-search>
